import {
  CircularProgress,
  styled,
  Typography,
  Button as MUIButton,
} from '@mui/material';
import { Refresh } from '@mui/icons-material';
import React from 'react';

const ResubmitButton = styled(MUIButton)({
  background: '#000',
  color: '#FFF',
  fontSize: '13px',
  '&:hover': {
    background: 'rgba(0, 0, 0, 0.85)',
  },
});

const SubmitButton = styled(MUIButton)({
  background: '#000',
  color: '#FFF',
  fontSize: '13px',
  '&:hover': {
    background: '#2196F3',
  },
  '&:disabled': {
    background: '#ccc',
    color: '#666',
  },
});

function SubmitButtons(props) {
  const getSubmitButtons = () => {
    if (props.isTerminated || !props.canSubmitSubmission) return <></>;
    return (
      <>
        {props.hasBeenSubmitted ? (
          <>
            <Typography
              className={props.classes.instructions}
              id={`submit-text-${props.form.current_index}`}
            >
              Click to re-submit this form
            </Typography>
            <ResubmitButton
              disabled={
                (props.sended ||
                  props.pageProcessing ||
                  !props.canSubmitSubmission ||
                  props.readOnly ||
                  props.previewMode) &&
                !props.isTest
              }
              variant="contained"
              onClick={props.openResubmitDialog}
              startIcon={<Refresh />}
              fullWidth
            >
              Resubmit
              {props.pageProcessing && (
                <CircularProgress className="buttonProgress" size={20} />
              )}
            </ResubmitButton>
          </>
        ) : (
          <>
            <SubmitButton
              disabled={
                (props.sended ||
                  props.pageProcessing ||
                  !props.canSubmitSubmission ||
                  props.readOnly ||
                  props.previewMode) &&
                !props.isTest
              }
              variant="contained"
              onClick={props.handleSubmit}
              fullWidth
            >
              Submit{' '}
              {props.pageProcessing && (
                <CircularProgress className="buttonProgress" size={20} />
              )}
            </SubmitButton>
          </>
        )}
      </>
    );
  };

  return getSubmitButtons();
}

export default SubmitButtons;
